// Order Timeline – logic (dates + animation)
(function(){
  function pad(n){ return String(n).padStart(2,'0'); }
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const fmt = d => `${months[d.getMonth()]} ${pad(d.getDate())}`;
  const add = (d,n)=>{ const x=new Date(d); x.setDate(x.getDate()+Number(n||0)); return x; };

  function init(box){
    const prod = Number(box.getAttribute('data-prod') || 5);
    const tmin = Number(box.getAttribute('data-tmin') || 2);
    const tmax = Number(box.getAttribute('data-tmax') || 5);
    const cutoff = Number(box.getAttribute('data-cutoff') || 14);

    const now = new Date();
    let order = new Date(now);
    if(now.getHours() >= cutoff){ order = add(now, 1); } // after cutoff → next day

    const ship      = add(order, prod);
    const deliverS  = add(ship, tmin);
    const deliverE  = add(ship, tmax);

    // inject dates
    const setTxt = (sel, txt)=>{ const el = box.querySelector(sel); if(el) el.textContent = txt; };
    setTxt('[data-date="order"]',   fmt(order));
    setTxt('[data-date="ship"]',    fmt(ship));
    setTxt('[data-date="deliver"]', `${fmt(deliverS)} – ${fmt(deliverE)}`);
    setTxt('.otp-range',            `${fmt(deliverS)} to ${fmt(deliverE)}`);

    // progress value
    let p = 0;
    if(now < ship) p = 0.33;
    else if(now >= ship && now < deliverS) p = 0.66;
    else p = 1;

    // apply width and truck position using CSS var --pct
    const pct = Math.round(p*100) + '%';
    box.style.setProperty('--pct', pct);

    // step states
    const steps = box.querySelectorAll('.otp-step');
    steps[0].classList.add('is-done');
    if(p >= 0.66) steps[1].classList.add('is-done'); else if(p >= 0.33) steps[1].classList.add('is-active');
    if(p >= 1) steps[2].classList.add('is-done');
  }

  function boot(){
    document.querySelectorAll('.otp').forEach(init);
  }

  // Dawn loads sections dynamically — listen for loads, too
  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
